<template>
    <div class="card shadow-sm mb-4">
        <div class="card-header text-white bg-secondary fw-bold">Completed Visits</div>
        <div class="card-content p-2">
            <div v-if="!visit_loading">
                <span v-if="Object.keys(props.completed_visits).length">
                    <a :href="'/#/visit/' + visit.id" v-for="visit in props.completed_visits" v-bind:key="visit.id" class="col-12 d-block visit-card-anchor" @click="router.push({name:'visit',params:{visit_id:visit.id}})">
                        <div class="row visit-card">
                            <div class="col-10">
                                <img :src="visit.scenario.patient_image.location" class="rounded-circle float-start me-2" width="75" />
                                <div class="border-end time-slot float-start pt-3 me-2">
                                    <span class="text-secondary fw-bold">{{ moment(visit.utc_time || visit.local_time).format('MM/DD/YY') }}</span>
                                    <hr class="my-1">
                                    <span class="text-primary fw-bold">{{ moment(visit.utc_time || visit.local_time).format('h:mm') }}<sup>{{ moment(visit.utc_time || visit.local_time).format('a') }}</sup></span>
                                </div>
                                <div class="mobile-visit-card overflow-hidden">
                                    <div class="fw-bold text-secondary">{{visit.scenario.patient_name}}</div>
                                    <div>{{visit.scenario.title}}</div>
                                    <div v-if="is_admin" class="m-1">
                                        <small class="text-secondary">{{visit.partner.slug}}</small>
                                        <br>
                                        <small v-if="!is_client_admin" class="text-secondary">Standardized Patient</small>
                                        <br v-if="!is_client_admin">
                                        <small v-if="!is_client_admin">{{visit.standardized_patient.name}} ({{visit.standardized_patient.email}})</small>
                                        <br v-if="!is_client_admin">
                                        <small class="text-secondary">Participant</small>
                                        <br>
                                        <small>{{visit.learner.name}} ({{visit.learner.email}})</small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center">
                                <h3 class="text-center"><i class='fas fa-check text-primary'></i></h3>
                            </div>
                        </div>
                        <hr class="w-75" />
                    </a>
                    <lazy-pagination v-if="completed_visits_total > 10" :items="props.completed_visits" :total="props.completed_visits_total" :page_start="page_start" :page_end="page_end" v-on:next-page="nextPage" v-on:previous-page="previousPage" :label="'Visits'" />
                </span>
                <p v-else class="text-center pt-3">No Completed Visits</p>
            </div>
            <div class="loading-card-area" v-else>
                <loading :active="visit_loading" :is-full-page="false"></loading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineComponent, ref} from "vue";
    import Loading from 'vue3-loading-overlay';
    import moment from 'moment';
    import LazyPagination from '@/components/dashboard/lazy-pagination.vue';
    import router from "@/router";

    export default defineComponent({
        emits: ['change-page'],
        components: {
            Loading,
            LazyPagination
        },
        props: {
            reset_pagination: {type:Boolean, default: false},
            completed_visits: {type:Object,required:true},
            completed_visits_total: {type:Number, required:true},
            visit_loading: {type:Boolean, required:true},
            is_admin: {type:Boolean, required:false},
            is_client_admin: {type:Boolean, default:false}
        },
        watch: {
            reset_pagination: function(reset){
                if(reset){
                    this.page_start = 0;
                    this.page_end = 10;
                }
            },
        },
        setup(props, {emit}) {
            const page_start = ref(0);
            const page_end = ref(10);
            const nextPage = async() => {
                page_start.value = page_start.value + 10;
                page_end.value = page_end.value + 10;
                if(page_end.value > props.completed_visits_total){
                    page_end.value = props.completed_visits_total;
                }
                emit('change-page',{type:'completed','page_start':page_start.value});
            };
            const previousPage = async() => {
                page_start.value = page_start.value - 10;
                page_end.value = page_start.value + 10;
                emit('change-page',{type:'completed','page_start':page_start.value});
            };
            return {
                moment,
                nextPage,
                page_start,
                page_end,
                previousPage,
                props,
                router,
            };
        }
    });
</script>
